import { IChartContainer } from "../../models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "../../models/chart-style/chart-style-settings.model";
import { IComponent } from "../component.interface";

export class AddIndicatorsButtonComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.subscribeChartService();
        this.onClick();
    }

    private subscribeChartService() {
        this.base.chartService.subscribeChartStyleData((data: ChartStyleSettingsModel) => {
            if (data.webBasedIndicatorManagerSupported && data.chartSettingsPopupModel?.displayNewIndicatorManager) {
                this.element.addClass('hidden');
            } else {
                this.element.removeClass('hidden');
            }
        });
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.base.chartService.requestAddIndicators();
        });
    }
}